import React from 'react';
import PropTypes from 'prop-types';
import {
  ShopifyErrorPage,
  FlexContent,
  DescriptionLabel,
  TopImage,
  TitleLabel,
  BackButton,
} from './CommonError.styles';

const CommonError = ({ setSelectedTask }) => {
  const exitAction = function () {
    setSelectedTask(null);
  };

  return (
    <ShopifyErrorPage className="text-center">
      <FlexContent>
        <div className="row">
          <div className="col-xs-12">
            <TopImage className="svg" alt="" src="/images/x-green.svg" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <TitleLabel>Something went wrong!</TitleLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <DescriptionLabel>An error occurred while performing your action, please try again.</DescriptionLabel>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-center">
            <BackButton type="button" className="btn" onClick={exitAction}>
              BACK TO ACTIONS
            </BackButton>
          </div>
        </div>
      </FlexContent>
    </ShopifyErrorPage>
  );
};

CommonError.propTypes = {
  setSelectedTask: PropTypes.func.isRequired,
};

export default CommonError;
